import { isTesting } from "@embroider/macros";

export default {
  initialize(applicationInstance) {
    // Instantiation of the service starts the regular fetch of the new version.
    if (!isTesting()) {
      applicationInstance.lookup("service:new-version");
    }
  }
};
